import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Header = () => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Fermer le menu mobile lors d'un clic en dehors
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Vérifier si le menu est ouvert et si le clic est en dehors du menu
      if (isMobileMenuOpen && !event.target.closest('.mobile-menu-container') && !event.target.closest('.mobile-menu-button')) {
        setIsMobileMenuOpen(false);
      }
    };

    // Ajouter l'écouteur d'événements
    document.addEventListener('click', handleClickOutside);

    // Nettoyer l'écouteur d'événements lors du démontage
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isMobileMenuOpen]);

  const toggleMobileMenu = (e) => {
    // Empêcher la propagation pour éviter que handleClickOutside ne soit déclenché
    if (e) e.stopPropagation();
    console.log('Toggle menu, état actuel:', isMobileMenuOpen);
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header 
      className="bg-white z-30 w-full max-w-full overflow-visible relative" 
      style={{ 
        boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
        paddingTop: '.3rem',
        paddingBottom: '.3rem',
        transition: 'box-shadow 0.3s ease-in-out'
      }}
    >
      <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8 w-full">
        {/* Desktop Navigation */}
        <div className="hidden md:flex justify-center items-center h-16 w-full">
          <div className="flex justify-between items-center w-full max-w-5xl">
            {/* Bouton Payer l'expédition */}
            <button
              className="btn-header btn-payment uppercase text-sm"
              onClick={() => navigate('/payment')}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z" />
                <path fillRule="evenodd" d="M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z" clipRule="evenodd" />
              </svg>
              Payer l&apos;expédition
            </button>
            
            {/* Logo au centre */}
            <Link to="/" className="flex-shrink-0 flex items-center mx-4">
              <img src="/assets/img/logo-cgciparis.png" alt="Logo Services Consulaires" className="h-16" style={{ maxHeight: '100px', width: 'auto' }} />
            </Link>
            <div className="relative flex items-center space-x-2">
              {/* Bouton Facebook */}
              <a 
                href="https://www.facebook.com/cgci.paris" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="flex items-center space-x-2 bg-white text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-100 transition-colors border border-gray-300 mr-2"
              >
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  width="24" 
                  height="24" 
                  viewBox="0 0 24 24" 
                  fill="#1877F2" 
                  className="w-6 h-6 mr-2"
                >
                  <path d="M12 2.04C6.5 2.04 2 6.53 2 12.06C2 17.06 5.66 21.21 10.44 21.96V14.96H7.9V12.06H10.44V9.85C10.44 7.34 11.93 5.96 14.22 5.96C15.31 5.96 16.45 6.15 16.45 6.15V8.62H15.19C13.95 8.62 13.56 9.39 13.56 10.18V12.06H16.34L15.89 14.96H13.56V21.96C18.34 21.21 22 17.06 22 12.06C22 6.53 17.5 2.04 12 2.04Z"/>
                </svg>
                
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  className="h-4 w-4 ml-2" 
                  fill="none" 
                  viewBox="0 0 24 24" 
                  stroke="currentColor"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" 
                  />
                </svg>
              </a>

              {/* Bouton Suivi de demande */}
              <a 
                href="https://paris.diplomatie.gouv.ci/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="flex items-center space-x-2 bg-white text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-100 transition-colors border border-gray-300"
              >
                <img 
                  src="/assets/img/drapeau-civ.png" 
                  alt="Drapeau de la Côte d'Ivoire" 
                  className="w-6 h-4 mr-2" 
                />
                Site officiel
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  className="h-4 w-4 ml-2" 
                  fill="none" 
                  viewBox="0 0 24 24" 
                  stroke="currentColor"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" 
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Mobile Navigation */}
        <div className="md:hidden flex justify-between items-center h-16 w-full">
          {/* Mobile Menu Toggle */}
          <button
            onClick={toggleMobileMenu}
            type="button"
            className="mobile-menu-button inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary"
            aria-expanded={isMobileMenuOpen}
          >
            <span className="sr-only">Ouvrir le menu principal</span>
            {isMobileMenuOpen ? (
              <svg
                className="block h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            ) : (
              <svg
                className="block h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            )}
          </button>

          {/* Mobile Logo */}
          <Link to="/" className="flex-shrink-0 flex items-center">
            <img src="/assets/img/logo-cgciparis.png" alt="Logo Services Consulaires" className="h-12" style={{ maxHeight: '80px', width: 'auto' }} />
          </Link>

          {/* Mobile actions */}
          <div className="relative flex items-center space-x-2">
            {/* Facebook icon */}
            <a 
              href="https://www.facebook.com/cgci.paris" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="flex items-center text-gray-700 mr-2"
            >
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                width="24" 
                height="24" 
                viewBox="0 0 24 24" 
                fill="#1877F2" 
                className="w-6 h-6"
              >
                <path d="M12 2.04C6.5 2.04 2 6.53 2 12.06C2 17.06 5.66 21.21 10.44 21.96V14.96H7.9V12.06H10.44V9.85C10.44 7.34 11.93 5.96 14.22 5.96C15.31 5.96 16.45 6.15 16.45 6.15V8.62H15.19C13.95 8.62 13.56 9.39 13.56 10.18V12.06H16.34L15.89 14.96H13.56V21.96C18.34 21.21 22 17.06 22 12.06C22 6.53 17.5 2.04 12 2.04Z"/>
              </svg>
            </a>
            
            {/* Official site icon */}
            <a 
              href="https://paris.diplomatie.gouv.ci/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="flex items-center text-gray-700"
            >
              <img 
                src="/assets/img/drapeau-civ.png" 
                alt="Drapeau de la Côte d'Ivoire" 
                className="w-6 h-4" 
              />
            </a>
          </div>
        </div>

        {/* Mobile Menu Dropdown */}
        <div 
          className={`mobile-menu-container md:hidden absolute left-0 right-0 top-[calc(100%_-_1px)] bg-white shadow-lg w-full z-50 transition-all duration-300 ${isMobileMenuOpen ? 'max-h-96 opacity-100 visible' : 'max-h-0 opacity-0 overflow-hidden invisible'}`}
        >
          <div className="px-4 pt-2 pb-3 space-y-1 w-full">
            <button
              onClick={() => {
                navigate('/payment');
                toggleMobileMenu();
              }}
              className="w-full text-left block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-100"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 inline-block mr-2" viewBox="0 0 20 20" fill="currentColor">
                <path d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z" />
                <path fillRule="evenodd" d="M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z" clipRule="evenodd" />
              </svg>
              Payer l&apos;expédition
            </button>
            <a 
              href="https://www.facebook.com/cgci.paris" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-100"
            >
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                width="24" 
                height="24" 
                viewBox="0 0 24 24" 
                fill="#1877F2" 
                className="w-6 h-6 inline-block mr-2"
              >
                <path d="M12 2.04C6.5 2.04 2 6.53 2 12.06C2 17.06 5.66 21.21 10.44 21.96V14.96H7.9V12.06H10.44V9.85C10.44 7.34 11.93 5.96 14.22 5.96C15.31 5.96 16.45 6.15 16.45 6.15V8.62H15.19C13.95 8.62 13.56 9.39 13.56 10.18V12.06H16.34L15.89 14.96H13.56V21.96C18.34 21.21 22 17.06 22 12.06C22 6.53 17.5 2.04 12 2.04Z"/>
              </svg>
              Facebook
            </a>
            <a 
              href="https://paris.diplomatie.gouv.ci/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-100"
            >
              <img 
                src="/assets/img/drapeau-civ.png" 
                alt="Drapeau de la Côte d'Ivoire" 
                className="w-6 h-4 inline-block mr-2" 
              />
              Site officiel
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
